import styled from 'styled-components'

export const FormWrapper = styled.form`
  input {
    border-color: var(--grey4);
    color: var(--grey2);

    ::placeholder {
      color: var(--grey3);
    }

    ::-webkit-input-placeholder {
      color: var(--grey3);
    }

    ::-moz-placeholder {
      color: var(--grey3);
      opacity: 1;
    }
  }

  label {
    font-size: 16px;
    color: var(--grey2);
    margin-bottom: 0.25rem;

    &.checkbox-label {
      width: fit-content;
    }
  }

  section:not(:last-of-type) {
    margin-bottom: 1.5rem;
  }

  section:last-of-type {
    margin-bottom: 1rem;
  }

  a {
    text-decoration: none;
    font-weight: 700;
    color: var(--grey7);
  }

  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    margin-right: 0.5rem;
    border: 1px solid var(--grey6);
    border-radius: 0.3125rem;
    cursor: pointer;
  }

  .photo {
    width: 100%;

    .flexbox {
      margin-bottom: 1rem;
    }

    .properties {
      display: flex;
      flex-direction: column;
      align-self: stretch;
      justify-content: center;
      margin-left: 1.5rem;

      & > p:first-child {
        margin-bottom: 1.5rem;
      }
    }

    img {
      border-radius: 50%;
      float: left;
    }
  }

  .react-tel-input .form-control {
    width: 100%;
    height: 41px;
    border: 1px var(--grey4) solid;
  }

  .react-tel-input {
    margin: 5px 0;
  }

  form::placeholder,
  select {
    color: var(--grey3);
  }

  #reminders {
    label {
      color: var(--grey7);
    }

    & * {
      font-size: 14px;
    }
  }

  #btn_back,
  #btn_resendtoken {
    font-size: 16px;
  }

  #btn_wrapper {
    width: fit-content;
    margin-left: auto;
  }

  .link-button,
  .icon-button {
    background: none;
    margin: 0;
    width: fit-content;
    color: var(--grey2);
  }

  .link-button {
    text-decoration: underline;
  }

  .icon-button span:first-of-type {
    margin-right: 0.5rem;
  }

  #btn_sendtoken {
    margin-top: 30px;
  }

  #btn_access_portal {
    font-size: 14px;
  }

  @media only screen and (max-width: 768px) {
    //MOBILE

    input,
    .flexbox > label {
      font-size: 14px;
    }

    input[type='checkbox'] {
      width: 25px;
    }

    #btn_access_portal {
      font-size: 12px;
      padding: 1rem 1.2rem;
      height: auto;
    }
  }

  #btn_access_portal {
    font-size: 14px;
    height: auto;
  }
`
export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  margin-top: 33px;
  margin-bottom: 29px;
  gap: 7px;

  .line {
    flex: 1;
    height: 1px;
    background-color: var(--grey4);
  }

  .text {
    font-family: Inter;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    color: var(--grey3);
    white-space: nowrap;
  }
`

export const HelpAccessButton = styled.a`
  display: block !important;
  width: fit-content !important;
  margin: 30px auto 0 !important;
  cursor: pointer !important;
  padding: 0 !important;
  background: none !important;
  border: none !important;
  font-family: Inter !important;
  font-weight: 400 !important;
  font-style: normal !important;
  font-size: 16px !important;
  line-height: 100% !important;
  letter-spacing: 0% !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-underline-offset: 2px !important;
  color: var(--blue) !important;
`

export const CropperContainer = styled.div`
  position: relative;
  height: 200px;
  margin-bottom: 3rem;
`
